import React, { useState, useEffect, forwardRef } from "react";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "components/Loader/Loader";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const useStyles = makeStyles(theme =>({
  ...styles,
  cardTitle: {
    marginTop: "0",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  select: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    color: "#D2D2D2",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "1.42857",
    letterSpacing: "unset",
    "&:before": {
      borderColor: "#D2D2D2",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "1.42857",
      letterSpacing: "unset"
    },
    "&:after": {
      borderColor: "#D2D2D2",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "1.42857",
      letterSpacing: "unset"
    }
  },
  container: {
    textAlign: "center"
  },
  content: {
    display: "inline-flex",
    padding: "10px",
    alignItems: "center"
  },
  paddingBottomCard: {
    paddingBottom: "40px"
  },
  marginRight: {
    marginRight: "10px"
  },
  marginBottom: {
    marginBottom: "50px"
  },
  formControl: {
    marginTop: theme.spacing(3.5),
    minWidth: "100%"
  },
  formControl2: {
    minWidth: "100%",
    marginTop: theme.spacing(5)
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

export default function Dashboard() {
  const classes = useStyles();

  const [calificadores, setCalificadores] = useState([]);
  const [ejecutivos, setEjecutivos] = useState([]);
  const [preguntas, setPreguntas] = useState([]);
  const [rows, setRows] = useState([]);

  const [selectFechaInicio, setSelectedFechaInicio] = useState(new Date());
  const [selectFechaFin, setSelectedFechaFin] = useState(new Date());

  const [IdAuditor, setIdAuditor] = useState("0");
  const [IdEjecutivo, setIdEjecutivo] = useState("0");
  const [Ventas, setVentas] = useState(0);
  const [Monitoreos, setMonitoreos] = useState(0);
  const [Promedio, setPromedio] = useState(0);
  const [MonitoreosAuditor, setMonitoreosAuditor] = useState(0);

  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [load, setLoad] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const sendSnackBar = (pmessage, pcolor) => {
    setOpenSnackbar(true);
    setColor(pcolor);
    setMessage(pmessage);
  };

  const Login = async () => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
            headers: {
                "Content-Type": "application/json"
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Login",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ObtieneCalificadores = async (token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Calificacion/ObtieneCalificadores",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ObtieneEjecutivos = async (token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Calificacion/ObtieneEjecutivos",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ObtienePromedios = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Calificacion/ObtienePromedios",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ObtienePreguntasPromedios = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Calificacion/ObtienePreguntasPromedios",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ObtieneCapturistasPromedio = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Calificacion/ObtieneCapturistasPromedio",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ObtienePreguntas = async (token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Preguntas/ObtienePreguntas",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const handeSubmit = event => {
    event.preventDefault();
    try{
        setLoad(true);

        let fechaInicio = moment(selectFechaInicio);
        fechaInicio.set({h: 0, m: 0, s: 0});

        let fechaFin = moment(selectFechaFin);
        fechaFin.set({h: 23, m: 59, s: 59});

        Login()
        .then(result => {
          let body = {
              FechaInicio: fechaInicio.format("YYYY/MM/DD HH:mm:ss"),
              FechaFin: fechaFin.format("YYYY/MM/DD HH:mm:ss"),
              Capturista: parseInt(IdAuditor),
              Ejecutivo: parseInt(IdEjecutivo)          
            };

          ObtienePromedios(body, result.token)
          .then(result => {
            setVentas(result.promedios.Ventas);
            setMonitoreos(result.promedios.Monitoreos);
            setPromedio(result.promedios.Promedio);
            setMonitoreosAuditor(result.promedios.MonitoreosAuditor);

            setLoad(false);
          }).catch(error => sendSnackBar("Error de conexión", "error"));

          ObtienePreguntasPromedios(body, result.token)
          .then(result => {
            const pre = preguntas.map((item) => {
              let pro = result.preguntasPromedio.find(element => element.IdPreguntas === item.IdPreguntas);
              return {
                  IdPreguntas: item.IdPreguntas,
                  Calificacion: item.Calificacion,
                  Pregunta : item.Pregunta,
                  Promedio: pro === undefined ? 0 : pro.Promedio
              };
            });

            setPreguntas(pre);
          }).catch(error => sendSnackBar("Error de conexión", "error"));

          ObtieneCapturistasPromedio(body, result.token)
          .then(result => {
            console.log(result.capturistasPromedio);
            let registros = result.capturistasPromedio.map((item) => {
              return { 
                capturista: item.Capturista, 
                ventas: item.Ventas, 
                monitoreos: item.Monitoreos, 
                promedio: item.Promedio
              }

            });

            setRows(registros);
          }).catch(error => sendSnackBar("Error de conexión", "error"));
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    } catch(error){
        sendSnackBar("Error de conexión", "error");
        setLoad(false);
    }
  };

  useEffect(() => {
    Login()
    .then(result => {
      ObtieneCalificadores(result.token)
      .then(result => {
        setCalificadores(result.calificadores);
      }).catch(error => sendSnackBar("Error de conexión", "error"));

      ObtieneEjecutivos(result.token)
      .then(result => {
        setEjecutivos(result.ejecutivos);
      }).catch(error => sendSnackBar("Error de conexión", "error"));

      ObtienePreguntas(result.token)
      .then(result => {
          const pre = result.preguntas.map((item) => {
              return {
                  IdPreguntas: item.IdPreguntas,
                  Calificacion: item.Calificacion,
                  Pregunta : item.Pregunta,
                  Promedio: 0
              };
          });

          setPreguntas(pre);
      }).catch(error => sendSnackBar("Error de conexión", "error"));
    }).catch(error => sendSnackBar("Error de conexión", "error"));
  }, []);

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid className={classes.marginBottom}>
          <Grid container className={classes.paddingBottomCard}>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    format="yyyy/MM/dd"
                    label="Fecha inicio"
                    value={selectFechaInicio}
                    onChange={(date) => setSelectedFechaInicio(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    label="Fecha Final"
                    format="yyyy/MM/dd"
                    value={selectFechaFin}
                    onChange={(date) => setSelectedFechaFin(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <TextField
                  select
                  label="Auditor"
                  value={IdAuditor} 
                  onChange={(event) => setIdAuditor(event.target.value)} 
                  style={{ width: "100%", marginTop: "35px" }}
                  className={classes.formControl}
              >
                  <MenuItem value={0}>
                      {'Todos'}
                  </MenuItem>
                  {calificadores.map((option) => (
                      <MenuItem key={option.IdUsuario} value={option.IdUsuario}>
                          {option.Nombre}
                      </MenuItem>
                  ))}
              </TextField>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <TextField
                  select
                  label="Ejecutivo"
                  value={IdEjecutivo} 
                  onChange={(event) => setIdEjecutivo(event.target.value)} 
                  style={{ width: "100%", marginTop: "35px" }}
                  className={classes.formControl}
              >
                  <MenuItem value={0}>
                      {'Todos'}
                  </MenuItem>
                  {ejecutivos.map((option) => (
                      <MenuItem key={option.IdUsuario} value={option.IdUsuario}>
                          {option.Nombre}
                      </MenuItem>
                  ))}
              </TextField>
            </GridItem>
          </Grid>
          <Grid container spacing={3} style={{marginLeft: "1px"}}>
            <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={e => {
                  handeSubmit(e);
                }}
                color="info"
              >
                Buscar
              </Button>
            </GridItem>
          </Grid>
        </Grid>
      </LocalizationProvider>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader stats icon>
              <p className={classes.cardCategory}>Ventas</p>
              <h3 className={classes.cardTitle} style={{color: "black"}}>{Ventas}</h3>
            </CardHeader>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader stats icon>
              <p className={classes.cardCategory}>Monitoreos</p>
              <h3 className={classes.cardTitle} style={{color: "black"}}>{Monitoreos}</h3>
            </CardHeader>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader stats icon>
              <p className={classes.cardCategory}>% Monitoreos</p>
              <h3 className={classes.cardTitle} style={{color: "black"}}>{Promedio}</h3>
            </CardHeader>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader stats icon>
              <p className={classes.cardCategory}>Monitoreos por auditor</p>
              <h3 className={classes.cardTitle} style={{color: "black"}}>{MonitoreosAuditor}</h3>
            </CardHeader>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card style={{ marginBottom: "30px" }}>
            <Grid container spacing={3} style={{ padding: "30px" }}>
                <Grid item xs={12} sm={12} xl={12}>
                    <Typography variant="h6">
                        Preguntas
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} xl={6}>
                    <Typography variant="h6"></Typography>
                </Grid>
                <Grid item xs={12} sm={3} xl={3} style={{display: "flex"}}>
                    <Typography variant="subtitle1" style={{margin: "auto"}}>
                        Promedio
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={3} xl={3} style={{display: "flex"}}>
                    <Typography variant="subtitle1" style={{margin: "auto"}}>
                        Meta
                    </Typography>
                </Grid>
                {preguntas.map((column) => (
                    <Grid item xs={12} sm={12} xl={12} key={column.IdPreguntas}>
                        <Grid container>
                            <Grid item xs={12} sm={6} xl={6} style={{borderColor: "#2196F3", display: "flex", backgroundColor: "#c1e1ec", borderLeft: "6px solid #2196F3", padding: "10px"}}>
                                <Typography variant="body1" style={{color: "black", margin: "auto" }}>{column.Pregunta}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={3} xl={3} style={{backgroundColor: "#d4ebf2", display: "flex"}}>
                              <Typography variant="body1" style={{color: "black", margin: "auto" }}>{column.Promedio}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={3} xl={3} style={{backgroundColor: "#e8f4f8", display: "flex"}}>
                              <Typography variant="body1" style={{color: "black", margin: "auto" }}>{column.Calificacion}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
              </Grid>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Capturista</TableCell>
                  <TableCell align="right">Ventas</TableCell>
                  <TableCell align="right">Monitoreos</TableCell>
                  <TableCell align="right">Promedio calificación</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.capturista}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.capturista}
                    </TableCell>
                    <TableCell align="right">{row.ventas}</TableCell>
                    <TableCell align="right">{row.monitoreos}</TableCell>
                    <TableCell align="right">{row.promedio}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={handleClose} autoHideDuration={6000}>
            <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
                {message}
            </Alert>
      </Snackbar>
      <Loader load={load} />
    </div>
  );
}
